import React, { Component } from "react";
import { Container, Header, Button, Loader, Message } from "semantic-ui-react";
import Tree, { TreeNode } from "rc-tree";
import "rc-tree/assets/index.css";
import { observer } from "mobx-react";
import { mapValueToKey } from "utils/map-utils";
import { apiGatewayClientWithCredentials } from "services/api";
import { timeoutPromise } from "utils/function-utils";
import {
  updatePermission,
  getProfileDetail,
  getHostList,
  getMES15ApiColor,
  getMES16ApiColor,
  geApiGatewayApiColor,
} from "services/developer";
import { NotFound } from "components/NotFound";
import { TIMEOUT_DURATION } from "env.config";
export default observer(
  class Permission extends Component {
    constructor(props) {
      super(props);
      this.state = {
        treeData: [],
        defaultExpandedKeys: [],
        checkedKeys: [],
        checkedL3Items: [],
        profileDetail: null,
        l3Items: [],
        isLoading: true,
        showSuccessMessage: false,
        showErrorMessage: false,
        errorMessage: "",
        successMessage: "",
        active: "",
        prefix: "",
      };
    }

    async componentDidMount() {
      const ProfileId = this.props.location.search.slice(
        this.props.location.search.indexOf("=") + 1
      );
      const [profileDetail, hostList] = await Promise.all([
        getProfileDetail({ ProfileId }),
        getHostList(),
      ]);
      if (!profileDetail || (profileDetail && !profileDetail.ProfileId)) {
        this.setState({ profileDetail, isLoading: false });
        return;
      }
      const { Scope, Stage, Host, MES } = profileDetail;
      const isMES16 = MES === "MES16" ? true : false;
      const prefix = await mapValueToKey(
        { scope: Scope, stage: Stage },
        isMES16
      );
      if (MES && MES === "MES16") {
        const res = await this.getColorStatus(TIMEOUT_DURATION, Host);
        const apigatewayVersion = await geApiGatewayApiColor(prefix);
        if (res === "error") {
          this.setState({
            profileDetail,
            errorMessage:
              "Unable to fetch site version due to timeout. Please try again later.",
            showSuccessMessage: false,
            showErrorMessage: true,
            isLoading: false,
          });
          return;
        }
        if (!res.version) {
          this.setState({
            profileDetail,
            errorMessage: "Unable to fetch site version.",
            showSuccessMessage: false,
            showErrorMessage: true,
            isLoading: false,
          });
          return;
        }
        // generic api, oauth api, erp api, default set green
        const activeList = [
          res.color || "green",
          apigatewayVersion.oauthApi || "green",
          apigatewayVersion.erpApi || "green",
        ];
        this.setState({
          version: res.version,
          active: activeList.join("_"),
        });
      } else {
        if (hostList.length) {
          const filteredHost = hostList.find(
            (host) => host.Scope === Scope && host.Stage === Stage
          );
          filteredHost && Object.assign(profileDetail, filteredHost);
        }
        const res = await getMES15ApiColor(prefix);
        this.setState({ active: res.active || "green" });
      }
      this.getProxyList(profileDetail, prefix);
      this.setState({ profileDetail });
    }

    getColorStatus = async (duration, url) => {
      return timeoutPromise(duration, getMES16ApiColor(url))
        .then((res) => res)
        .catch(() => {
          return "error";
        });
    };

    getProxyList = (profileDetail, prefix) => {
      const { active, version } = this.state;
      const versionParam = version ? version : undefined;
      const path =
        profileDetail.MES && profileDetail.MES === "MES16"
          ? `/admin/catalog/permission/MES16/${prefix}/version/${versionParam}/active/${active}`
          : `/admin/catalog/permission/MES15/${prefix}/active/${active}`;
      apiGatewayClientWithCredentials().then((app) => {
        return app
          .get(path, {}, {}, {})
          .then((res) => {
            const { treeData, defaultExpandedKeys, l3Items } = res.data;
            this.setState({
              treeData,
              defaultExpandedKeys,
              l3Items,
              isLoading: false,
            });
            this.setDefaultCheckedKeys(profileDetail);
          })
          .catch(() => {
            this.setState({ isLoading: false });
          });
      });
    };

    setDefaultCheckedKeys = (data) => {
      const { l3Items } = this.state;
      const permission = data.Permission;
      if (permission && permission.length) {
        const filteredPermission = l3Items.filter((p) =>
          permission.find(
            (l3) =>
              p.api === l3.api && p.path === l3.path && p.title === l3.title
          )
        );
        if (filteredPermission) {
          const checkedKeys = filteredPermission.map((item) => item.key);
          this.setState({ checkedKeys, checkedL3Items: filteredPermission });
        }
      }
    };

    savePermission = async () => {
      const { checkedL3Items, profileDetail, treeData } = this.state;
      if (treeData.length) {
        const { ProfileId, Scope, Stage, ProfileName } = profileDetail;
        const params = { ProfileId, Scope, Stage, ProfileName, checkedL3Items };
        const res = await updatePermission(params);
        if (res.success) {
          this.setState({
            successMessage: "Permission was updated successfully.",
            showSuccessMessage: true,
            showErrorMessage: false,
          });
        } else {
          this.setState({
            errorMessage: "Failed to update permission.",
            showSuccessMessage: false,
            showErrorMessage: true,
          });
        }
      }
    };

    goBack = (profileDetail) => {
      this.props.history.goBack();
    };

    onCheck = (checkedKeys) => {
      const { l3Items } = this.state;
      const keys = checkedKeys.filter((item) => item.indexOf("l3") === 0);
      const checkedL3Items = l3Items.filter((l3Item) =>
        keys.find((item) => l3Item.key === item)
      );
      this.setState({
        checkedKeys,
        checkedL3Items,
      });
    };

    render() {
      const {
        treeData,
        defaultExpandedKeys,
        profileDetail,
        isLoading,
        showSuccessMessage,
        showErrorMessage,
        errorMessage,
        successMessage,
      } = this.state;

      const successProfile = showSuccessMessage ? (
        <Message
          positive
          onDismiss={() => this.setState({ showSuccessMessage: false })}
          content={successMessage}
        />
      ) : null;

      const failProfile = showErrorMessage ? (
        <Message
          negative
          onDismiss={() => this.setState({ showErrorMessage: false })}
          content={errorMessage}
        />
      ) : null;

      if (isLoading) {
        return <Loader active />;
      }

      if (profileDetail && !profileDetail.ProfileId) {
        return <NotFound />;
      }
      const loop = (data) =>
        data.map((item) => {
          if (item.children) {
            return (
              <TreeNode key={item.key} title={item.title}>
                {loop(item.children)}
              </TreeNode>
            );
          }
          return <TreeNode key={item.key} title={item.title} />;
        });

      let treeNodes;
      if (this.treeNodes && this.notReRender) {
        treeNodes = this.treeNodes;
      } else {
        treeNodes = loop(treeData);
        this.treeNodes = treeNodes;
      }

      return (
        <Container fluid style={{ padding: "2em" }} id="permission-container">
          <Header as="h1">Define Permissions</Header>
          {successProfile}
          {failProfile}
          {profileDetail ? (
            <div className="permission-info-content">
              <div className="info-item">
                <div>
                  <b>Profile Name: </b>
                  {profileDetail.ProfileName} ({profileDetail.MES || "MES15"})
                </div>
              </div>
              <div className="info-item">
                <div>
                  <b>Scope: </b>
                  {profileDetail.Scope}
                </div>
                <div>
                  <b>Stage: </b>
                  {profileDetail.Stage}
                </div>
                <div>
                  <b>Host: </b>
                  {profileDetail.Host}
                </div>
              </div>
              <Button.Group className="btn-group" style={{ display: "block" }}>
                <Button content="Save" onClick={this.savePermission} />
                <Button
                  content="Back"
                  onClick={() => this.goBack(profileDetail)}
                />
              </Button.Group>
            </div>
          ) : null}
          {treeData.length ? (
            <Tree
              showIcon={false}
              checkable
              multiple={this.props.multiple}
              defaultExpandedKeys={defaultExpandedKeys}
              onCheck={this.onCheck}
              checkedKeys={this.state.checkedKeys}
            >
              {treeNodes}
            </Tree>
          ) : null}
        </Container>
      );
    }
  }
);
